import request from '@/utils/request'

// getPaymentList
export function getPaymentList(param) {
    let data = param
    return request({
      url: `/electricMaterial/epms6200/getPaymentList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

// epms6200Save
export function epms6200Save(param) {
    let data = param
    return request({
      url: `/electricMaterial/epms6200/epms6200Save`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }